module.exports = __webpack_public_path__ + "img/rights-3@2x.c865c10d.png";